import React, { useCallback, useEffect, useRef } from 'react';
import { Snackbar } from '../../State/Snackbar/SnackbarProvider';

import { Snack, Content, Action, Close } from './wrapper';
import { IconClose } from '../Icon';

const TIMEOUT = 10000;

interface SnackbarItemProps {
  snackbar: Snackbar;
  removeSnackbar: (id: number) => void;
  transform: (height: number) => void;
  disableRemove?: boolean;
  fixedTop?: boolean;
  fixedBottom?: boolean;
}

const SnackbarItem = ({
  snackbar,
  removeSnackbar,
  transform,
  disableRemove,
  fixedTop,
  fixedBottom,
}: SnackbarItemProps) => {
  const ref = useRef<HTMLDivElement | null>(null);

  // Timern sätts en gång per meddelande, men anroparen skickar ofta nya
  // callback-identiteter varje rendering. Den senaste läses via en ref så
  // att effekten inte behöver köras om (och ta bort meddelandet) för det.
  const latest = useRef({ removeSnackbar, transform });
  latest.current = { removeSnackbar, transform };

  const onClick = useCallback(() => latest.current.removeSnackbar(snackbar.id), [snackbar.id]);

  useEffect(() => {
    // Ett meddelande som inte ska stängas automatiskt får ingen timer
    if (disableRemove) return;

    setTimeout(() => {
      latest.current.removeSnackbar(snackbar.id);
    }, TIMEOUT);

    setTimeout(() => {
      if (ref.current?.clientHeight) {
        latest.current.transform(ref.current.clientHeight);
      }
    }, TIMEOUT - 300);

    setTimeout(() => {
      if (ref.current) {
        ref.current.style.opacity = '0';
        ref.current.style.transition = 'opacity 300ms ease';
      }
    }, TIMEOUT - 600);

    return () => {
      latest.current.removeSnackbar(snackbar.id);
    };
  }, [disableRemove, snackbar.id]);

  return (
    <Snack
      $type={snackbar.type}
      $fixedTop={fixedTop || false}
      $fixedBottom={fixedBottom || false}
      ref={ref}
    >
      <Content>{snackbar.reactNode}</Content>
      <Action>
        <Close onClick={onClick}>
          <IconClose />
        </Close>
      </Action>
    </Snack>
  );
};

export default SnackbarItem;
